import { Box } from "theme-ui";
import { GrLocation } from "react-icons/gr";
import * as React from 'react';
export default {
  Box,
  GrLocation,
  React
};